import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Light from './headers/light';
import AnimationRevealPage from 'helpers/AnimationRevealPage';
import Footer from "components/footers/FiveColumnWithInputForm.js";
import Swal from 'sweetalert2';
import axios from 'axios';
import AnnouncementBanner from 'components/AnnouncementBanner';

const CheckoutForm = () => {
    const token = localStorage.getItem('authToken');
    const role = localStorage.getItem('role');  // Assuming the role is saved in localStorage
    const navigate = useNavigate();
    const [cart, setCart] = useState([]);
    const [customer, setCustomer] = useState({
        Name: '',
        Phone: '',
        Email: '',  // Allow user to enter it instead of forcing a default value
        Address: '',
        City: '',
    });

    useEffect(() => {
        // Redirect if not logged in or if the role is not 'supplier'
        if (!token || role !== 'supplier') {
            Swal.fire('Erreur', 'Vous devez �tre connecté en tant que distributeur pour passer une commande.', 'error')
                .then(() => {
                    navigate('/login'); // Redirect to login page
                });
            return; // Exit early, don't load the rest of the page
        }

        const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
        setCart(storedCart);
    }, [token, role, navigate]);

    // Handle customer input change
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setCustomer((prev) => ({ ...prev, [name]: value }));
    };

    // Handle quantity change
    const handleQuantityChange = (productID, newQuantity) => {
        if (newQuantity < 1) return;

        const updatedCart = cart.map(item =>
            item.productID === productID ? { ...item, quantity: newQuantity } : item
        );
        setCart(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
    };

    // Handle item removal
    const handleRemoveItem = (productID) => {
        const updatedCart = cart.filter(item => item.productID !== productID);
        setCart(updatedCart);
        localStorage.setItem('cart', JSON.stringify(updatedCart));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!token) {
            Swal.fire('Erreur', 'Vous devez étre connecté pour passer une commande.', 'error');
            return;
        }

        try {
            // Create the customer
            const customerResponse = await axios.post('https://hbmdijital.online/api/supplier/customers/create', customer, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            const customerId = customerResponse.data.customer.CustomerID;

            // Create the order
            const orderData = {
                product_ids: cart.map(item => item.productID),
                quantities: cart.map(item => item.quantity),
                customer_id: customerId,
            };

            const orderResponse = await axios.post('https://hbmdijital.online/api/supplier/orders/create', orderData, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
            });

            // Show success message
            Swal.fire('Commande réussie!', 'Votre commande a été passée avec succés.', 'success');

            // Clear cart from localStorage
            localStorage.removeItem('cart');

            // Redirect user
            navigate('/Boutique');

        } catch (error) {
            // Log the full error object and details
            console.error("Error:", error.message);  // Logs the error message
            console.error("Stack trace:", error.stack);  // Logs the stack trace for more context

            if (error.response) {
                // If the error contains a response (server-side error)
                console.error("Response data:", error.response.data);
                console.error("Response status:", error.response.status);
                console.error("Response headers:", error.response.headers);

                // Check if the error response indicates account deletion
                if (error.response.data.error === 'Your account has been deleted.') {
                    Swal.fire('Erreur!', 'Votre compte a été supprimé.', 'error');
        localStorage.clear();
        navigate('/signup'); // Replace with the actual path to the register page


		
                } else {
                    Swal.fire('Erreur!', error.response.data.message || 'Il y a eu un probléme, veuillez réessayer.', 'error');
                }
            } else if (error.request) {
                // If the error contains a request (network error)
                console.error("Request data:", error.request);
                Swal.fire('Erreur!', 'Probléme de connexion réseau, veuillez réessayer.', 'error');
            } else {
                // For other errors (like bad configuration)
                console.error("Error details:", error);
                Swal.fire('Erreur!', 'Il y a eu un probléme, veuillez réessayer.', 'error');
            }
        }
    };

    return (
      <AnimationRevealPage>
    <Light />
            <AnnouncementBanner />

    <div className="container">
        <div className="row">
            <div className="col-xl-8">
                <div className="card border shadow-none">
                    <div className="card-body">
                        <h1>Récapitulatif de la commande</h1>
                        {cart.length > 0 ? (
                            <>
                                <ul className="list-group">
                                    {cart.map((item, index) => (
                                        <li className="list-group-item" key={index}>
                                            <div className="d-flex align-items-start border-bottom pb-3">
                                                <div className="me-4">
                                                    <img src={`https://hbmdijital.online/storage/${item.productImage}`} alt="" className="avatar-lg rounded" />
                                                </div>
                                                <div className="flex-grow-1 align-self-center overflow-hidden">
                                                    <h5 className="text-truncate font-size-18 text-dark">{item.productName}</h5>
                                                    <p className="text-muted mb-0">Prix: <strong>{item.productPrice} DH</strong></p>
                                                    <div className="d-flex align-items-center">
                                                        <span className="me-2">Quantité:</span>
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={item.quantity}
                                                            onChange={(e) => handleQuantityChange(item.productID, parseInt(e.target.value))}
                                                            min="1"
                                                            style={{ width: '60px' }}
                                                        />
                                                    </div>
                                                    <p className="mb-0">Total: <strong>{(item.productPrice * item.quantity).toFixed(2)} DH</strong></p>
                                                </div>
                                                <div className="flex-shrink-0 ms-2">
                                                    <a href="#" className="text-muted px-1" onClick={() => handleRemoveItem(item.productID)}>
                                                        <i className="mdi mdi-trash-can-outline" style={{ fontSize: '24px', cursor: 'pointer' }}></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                                <br /><br />
                                <h2>Informations client</h2>
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <input type="text" name="Name" placeholder="Nom" className="form-control" onChange={handleInputChange} required />
                                    </div>
                                    <div className="mb-3">
                                        <input type="text" name="Phone" placeholder="Téléphone" className="form-control" onChange={handleInputChange} required />
                                    </div>
                                    <div className="mb-3">
                                        <input type="text" name="Address" placeholder="Adresse" className="form-control" onChange={handleInputChange} required />
                                    </div>
                                    <div className="mb-3">
                                        <input type="text" name="City" placeholder="Ville" className="form-control" onChange={handleInputChange} required />
                                    </div>
                                    <button
                                        type="submit"
                                        className="btn"
                                        style={{
                                            backgroundColor: '#1e3d56',
                                            color: 'white',
                                            border: 'none',
                                            padding: '10px 20px',
                                            fontSize: '16px',
                                            borderRadius: '5px',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        Confirmer la commande
                                    </button>
                                </form>
                            </>
                        ) : (
                            <p>Votre panier est vide.</p>
                        )}
                    </div>
                </div>
            </div>

            <div className="col-xl-4">
                <div className="mt-5 mt-lg-0">
                    <div className="card border shadow-none">
                        <div className="card-header bg-transparent border-bottom py-3 px-4">
                            <h5 className="font-size-16 mb-0">Résumé de la commande</h5>
                        </div>
                        <div className="card-body p-4 pt-2">
                            <div className="table-responsive">
                                <table className="table mb-0">
                                    <tbody>
                                        <tr>
                                            <td>Sous-total :</td>
                                            <td className="text-end">
                                                {cart.reduce((total, item) => total + (item.productPrice * item.quantity), 0).toFixed(2)} DH
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Les frais de la livraison</td>
                                            <td className="text-end">40.00 DH</td>
                                        </tr>
                                        <tr className="bg-light">
                                            <th>Total :</th>
                                            <td className="text-end">
                                                <span className="fw-bold">
                                                    {(cart.reduce((total, item) => total + (item.productPrice * item.quantity), 0) + 40.00).toFixed(2)} DH
                                                </span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <Footer />
</AnimationRevealPage>
    );
};

export default CheckoutForm;
